import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
class EdNavigationDrawer extends Vue {
  
  @Prop({ required: true }) value: boolean;
  @Prop({ default: false }) absolute: boolean;
  @Prop({ default: false }) closeOnClickOutside: boolean;

  get isOpen () {
    return this.value;
  }

  handleClickOutside(event: MouseEvent) {
    if (!(event.target as HTMLElement).closest('.ed-navigation-drawer') && this.closeOnClickOutside && this.isOpen) {
      this.$emit('input', false);
    }
  }

  beforeDestroy() {
    document.removeEventListener('pointerdown', this.handleClickOutside);
  }

  @Watch('isOpen')
  onDrawerStateChange(newValue: boolean) {
    if (newValue) {
      setTimeout(() => {
        document.addEventListener('pointerdown', this.handleClickOutside);
      }, 100);
    } else {
      document.removeEventListener('pointerdown', this.handleClickOutside);
    }
  }
}

export default Vue.component('ed-navigation-drawer', EdNavigationDrawer);
